/**
 * Zustand „neue Version bereit" — ohne Abhängigkeit vom Service-Worker-Modul,
 * damit die Oberfläche (und ihre Tests) ihn lesen können. Gesetzt wird er in
 * `update.ts`.
 */

import { useSyncExternalStore } from 'react';

let available = false;
/** Der Server nimmt den Abgleich dieser Fassung nicht mehr an (426). */
let required = false;
let apply: (() => void) | null = null;
let check: (() => void) | null = null;
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) listener();
}

export function markUpdateAvailable(applyUpdate: () => void): void {
  available = true;
  apply = applyUpdate;
  notify();
}

/** `update.ts` meldet, wie nach einer neuen Fassung gesucht wird. */
export function setUpdateCheck(run: () => void): void {
  check = run;
}

/**
 * Der Server verlangt eine neuere Fassung: sofort nachsehen. Ohne Service
 * Worker (oder bevor er die neue Fassung kennt) lädt der Knopf einfach neu.
 */
export function markUpdateRequired(): void {
  if (!required) {
    required = true;
    notify();
  }
  check?.();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useUpdateAvailable(): {
  available: boolean;
  required: boolean;
  apply: () => void;
} {
  const isAvailable = useSyncExternalStore(subscribe, () => available);
  const isRequired = useSyncExternalStore(subscribe, () => required);
  return {
    available: isAvailable || isRequired,
    required: isRequired,
    apply: () => (apply ? apply() : window.location.reload()),
  };
}
